import { useRouter } from 'next/router'

import { MapsTabTools as View, mapsSortOptions } from 'ui-components'

import { throttle } from 'utils'
import { useIsMyProfile } from '~user-profile/hooks/useIsMyProfile'

const MapsTabTools = (props) => {
  const router = useRouter()

  const isMyProfile = useIsMyProfile()

  const handleSearchMapsInputChange = (event) => {
    throttle(() => {
      const value = event.target.value

      const newQuery: Record<string, any> = { ...router.query, page: 1 }
      if (!value?.length) delete newQuery.query
      else newQuery.query = value

      router.replace({ query: newQuery }, undefined, {
        shallow: true
      })
    }, 500)
  }

  const handleSortChange = (event) => {
    const value = event.target.value
    router.replace({ query: { ...router.query, sortBy: value } }, undefined, {
      shallow: true
    })
  }

  return (
    <View
      {...props}
      canCreateMap={isMyProfile}
      slotProps={{
        SearchMapInput: {
          defaultValue: router.query?.query || '',
          onChange: handleSearchMapsInputChange
        },
        MapSortInput: {
          value: router.query.sortBy || mapsSortOptions[1]!.value,
          onChange: handleSortChange
        }
      }}
    />
  )
}

export { MapsTabTools }
